export * from './inline-loader/inline-loader.component';
